import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { PaymentMerchantList, PaymentConfirmation} from './components';
import { NotificationActions, ConfirmPaymentActions, MerchantActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    },
})

const IdentitySelector = (state) => state.Identity;

const ConfirmPayment = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const confirmPaymentActions = bindActionCreators(ConfirmPaymentActions, dispatch);
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { token, userData } = useSelector(IdentitySelector);

    const [mode, setMode] = useState('list');
    const [modeInfo, setModeInfo] = useState({ mode: 'list', merchant_id: '', merchant_name: '', merchant_type: '' });
    const [listRefresh, setListRefresh] = useState(true);

    const { classes } = props;

    /**
     *
     * 加盟店リスト画面表示
     *
     */
    const showList = () => {
        setListRefresh(false);
        setModeInfo({ mode: 'list', merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type });
    }

    /**
     *
     * 精算書確認リスト画面表示
     *
     * @param data 選択された行のデータ
     */
    const showDetail = (merchantId, merchantName, merchantType) => {
        setModeInfo({ mode: 'detail', merchant_id: merchantId, merchant_name: merchantName, merchant_type: merchantType });
    }

    useEffect(() => {
        if (userData.role == 1 || userData.role == 2 || userData.role == 3) {
            // システム管理者および沖縄ICカード、代表加盟店アカウント
            // 加盟店一覧表示
            setModeInfo({ mode: 'list', merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type });
        }
        else if (userData.role == 4) {
            // 一般加盟店アカウント
            // 加盟店情報を取得（loadProfileModelで取得しないと、権限不足で加盟店情報が取得できない）
            merchantActions.loadProfileModel(token, userData.org_id, userData.id)
                .then(data => {
                    // 精算書確認画面表示
                    setModeInfo({ mode: 'detail', merchant_id: data.id, merchant_name: data.merchant_name, merchant_type: data.merchant_type });
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }
    }, []);

    var listClass = classes.hiddenList;
    if (modeInfo.mode == 'list') {
        listClass = classes.visibleList;
    }

    var content = <div></div>;
    if (modeInfo.mode == 'detail') {
        content = <PaymentConfirmation onCancel={showList} merchantId={modeInfo.merchant_id} merchantName={modeInfo.merchant_name} merchantType={modeInfo.merchant_type} />
    }
   
    return (
        <div className={classes.root} maxWidth={false}>
            {content}
            <div className={listClass}>
                <PaymentMerchantList onDetail={showDetail} />
            </div>
        </div>
    )
}

export default withStyles(style, { withTheme: true })(ConfirmPayment);
